import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import TickWhite from '../../assets/img/icons/tick_2.svg';
import InputWithError from '../../components/Inputs/InputWithError';
import { PrimaryButton, SecondaryButton } from '../../styledComponents/buttons';
import {
  CommonFlex,
  CommonGrid,
  CommonText,
  InputLabel,
  InputWithLabelSection,
  RedStar,
} from '../../styledComponents/common';
import { CheckBoxSquare } from '../../styledComponents/tasks';
import Select from '../../components/ReactSelectDropdown';
import CreateProjectDropdown from 'components/DropdownStyle/CreateProjectDropdown';
import { filterOption } from 'components/ReactSelectDropdown/ReactSelectDropdown';

const AddItemModal = ({
  isOpen,
  toggle,
  handleAddItem,
  handleEditItem,
  isLoading,
  item,
}) => {
  const [itemName, setItemName] = useState('');
  const [sameAsPilgrims, setSameAsPilgrims] = useState(false);
  const [receiveSubTask, setReceiveSubTask] = useState('');
  const [decreaseSubTask, setDecreaseSubTask] = useState('');
  const [countingSubTask, setCountingSubTask] = useState('');
  const [saveErrors, setSaveErrors] = useState({});
  const [priority, setPriority] = useState('');
  const priorityOptions = [
    { label: 'High', value: 'high' },
    { label: 'No', value: 'no' },
  ];

  const onPriorityChange = e => setPriority(e);

  const toggleSameAsPilgrims = () => setSameAsPilgrims(!sameAsPilgrims);

  useEffect(() => {
    if (item) {
      setItemName(item.name);
      setSameAsPilgrims(item.same_as_pilgrims || false);
      setReceiveSubTask(item.receiveSubTask || '');
      setDecreaseSubTask(item.decreaseSubTask || '');
      setCountingSubTask(item.countingSubTask || '');
      setPriority(item.priority || '');
    } else {
      setSameAsPilgrims(true);
    }
  }, [item]);

  useEffect(() => {
    if (itemName) {
      setReceiveSubTask(`${t('receive')} ${itemName}`);
      setDecreaseSubTask(`${t('decrease')} ${itemName}`);
      setCountingSubTask(`${t('counting')} ${itemName}`);
    } else {
      setReceiveSubTask('');
      setDecreaseSubTask('');
      setCountingSubTask('');
    }
  }, [itemName]);

  const resetValues = () => {
    setItemName('');
    setSameAsPilgrims(true);
    setReceiveSubTask('');
    setDecreaseSubTask('');
    setCountingSubTask('');
    setPriority('');
  };

  const onItemNameChange = e => setItemName(e.target.value);

  const handleSubmit = () => {
    const payload = {
      itemName,
      same_as_pilgrims: sameAsPilgrims,
      receiveSubTask,
      decreaseSubTask,
      countingSubTask,
      priority: priority.value,
    };

    if (item) {
      handleEditItem(payload);
    } else {
      handleAddItem(payload);
    }
  };

  useEffect(() => {
    !isOpen && resetValues();
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      style={{
        width: 'max-content',
        maxWidth: '90%',
      }}
    >
      <ModalBody style={{ padding: `40px`, width: 'max-content' }}>
        <CommonFlex gap="15px" direction="column" alignItems="start">
          <CommonText name title fontSize="16px">
            {item ? t('edit_item') : t('add_new_item')}
          </CommonText>
          <CommonGrid alignItem="center">
            <InputWithError
              label={t('item_name')}
              placeholder={t('type_item_name')}
              value={itemName}
              onChange={onItemNameChange}
              error={saveErrors?.item_name}
            />
            <CommonFlex
              gap="5px"
              style={{
                height: '40px', marginTop: '8px',
              }}
            >
              <CheckBoxSquare
                checked={sameAsPilgrims}
                onClick={toggleSameAsPilgrims}
              >
                <img src={TickWhite} alt="tick" width="16px" height="16px" />
              </CheckBoxSquare>
              <CommonText margin="0" name>{`${t('quantity')} : ${t(
                'same_number_of_pilgrims',
              )}`}</CommonText>
            </CommonFlex>
          </CommonGrid>
          <InputWithLabelSection>
            <InputLabel>
              {t('priority')}
            </InputLabel>
            <Select
              isSearchable
              value={priority}
              options={priorityOptions}
              placeholder={t('select_priority')}
              isDisabled={isLoading}
              onChange={onPriorityChange}
              styles={CreateProjectDropdown()}
              filterOption={filterOption}
            />
          </InputWithLabelSection>
          <InputWithError
            margin="20px 0 0 0"
            width="50%"
            label={t('receive_sub_task')}
            placeholder={t('type_receive_sub_task')}
            value={receiveSubTask}
            onChange={() => {}}
            error={saveErrors?.receive_sub_task}
            readOnly
            required={false}
          />
          {/* <InputWithError
            margin="0"
            width="50%"
            label={t('decrease_sub_task')}
            placeholder={t('type_decrease_sub_task')}
            value={decreaseSubTask}
            onChange={() => {}}
            error={saveErrors?.decrease_sub_task}
            readOnly
            required={false}
          />
          <InputWithError
            margin="0 0 40px 0"
            width="50%"
            label={t('counting_sub_task')}
            placeholder={t('type_counting_sub_task')}
            value={countingSubTask}
            onChange={() => {}}
            error={saveErrors?.counting_sub_task}
            readOnly
            required={false}
          /> */}
        </CommonFlex>
        <CommonFlex>
          <SecondaryButton onClick={toggle}>{t('cancel')}</SecondaryButton>
          <PrimaryButton onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? t('saving') : item ? t('save_changes') : t('add_item')}
          </PrimaryButton>
        </CommonFlex>
      </ModalBody>
    </Modal>
  );
};

export default AddItemModal;
